import "react-app-polyfill/stable";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import "chart.js/auto";

import App from "./App";
import reportWebVitals from "./utils/reportWebVitals";
import { ThemeProvider } from "./contexts/ThemeContext";
import {
  AuthenticationResult,
  EventType,
  PublicClientApplication,
} from "@azure/msal-browser";
import { msalConfig } from "./authConfig";

const msalInstance = new PublicClientApplication(msalConfig);

// Handle redirect promise before initializing React
msalInstance
  .handleRedirectPromise()
  .then((response) => {
    if (response) {
      msalInstance.setActiveAccount(response.account);
    } else {
      // If no redirect response, check if there are accounts
      if (
        !msalInstance.getActiveAccount() &&
        msalInstance.getAllAccounts().length > 0
      ) {
        msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
      }
    }

    // Initialize React app after handling redirect
    const container = document.getElementById("root");
    const root = createRoot(container!);

    root.render(
      <BrowserRouter>
        <ThemeProvider>
          <App instance={msalInstance} />
        </ThemeProvider>
      </BrowserRouter>
    );
  })
  .catch((error) => {
    // console.error("Error handling redirect:", error);

    // Still render the app even if there's an error
    const container = document.getElementById("root");
    const root = createRoot(container!);

    root.render(
      <BrowserRouter>
        <ThemeProvider>
          <App instance={msalInstance} />
        </ThemeProvider>
      </BrowserRouter>
    );
  });

msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    const payload = event.payload as AuthenticationResult;
    if (payload.account) {
      msalInstance.setActiveAccount(payload.account);
    }
  }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
